@use "src/components/docs/inlineReference";

.docs {
  @include inlineReference.reference;
  min-height: 0;
  border: 0;
  padding: 0.1em 0.3em;
  font-weight: 400;
}

.value {
  font-family: var(--font-mono, monospace);
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}

.eventLink {
  color: inherit;
  font-size: inherit;
  text-decoration: none;
  vertical-align: middle;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 0.2em;
  }
}
